module.exports = __webpack_public_path__ + "img/bg01.8eab9066.jpg";